import { BaseFetch } from "../main-model"
export default class LessonLearnedModel extends BaseFetch {
    getLessonLearnedBy = (data) =>
        this.authFetch({
            url: "lesson-learned/getLessonLearnedBy",
            method: "POST",
            body: JSON.stringify(data),
        })
        getLessonLearnedById = (data) =>
        this.authFetch({
            url: "lesson-learned/getLessonLearnedById",
            method: "POST",
            body: JSON.stringify(data),
        })
        insertLessonLearned = (data) =>
        this.authFetch({
            url: "lesson-learned/insertLessonLearned",
            method: "POST",
            body: JSON.stringify(data),
        })
        updateLessonLearnedById = (data) =>
        this.authFetch({
            url: "lesson-learned/updateLessonLearnedById",
            method: "POST",
            body: JSON.stringify(data),
        })
        deleteLessonLearnedById = (data) =>
        this.authFetch({
            url: "lesson-learned/deleteLessonLearnedById",
            method: "POST",
            body: JSON.stringify(data),
        })
}
